import React, { useEffect, useState } from "react";
import Card from "../Card/card";
import { easyData, complexData } from "../../cards";
import './game.css';

function Game(props) {
  let [cardsState, setCardsState] = useState(easyData);

  let [firstCard, setFirstCard] = useState(null);
  let [secondClick, setSecondClick] = useState(false);
  let [wait, setWait] = useState(false);

  let [matches, setMatches] = useState(10);
  const timeOuts = {};

  useEffect(() => {
    for (let name in timeOuts) {
      if (timeOuts[name]) {
        clearTimeout(timeOuts[name]);
        delete timeOuts[name];
      }
    }

    if(props.gameState == 'start') {
      timeOuts.countingDown = setTimeout(() => {
        props.updateGameState('gaming');
      }, 3000);
    }
  }, [props.gameState]);

  useEffect(() => {
    if(!props.mode) return;

    setMatches(10);
    setFirstCard(null);
    setSecondClick(false);

    let newState = props.mode == 'EASY' ? [...easyData] : [...complexData];
    for(let card of newState) {
      card.isFlipped = false;
      card.passed =false;
      card.order = Math.floor(Math.random() * 20);
    }
    setCardsState(newState);
  }, [props.mode]);

  useEffect(() => {
    if(matches == 0) {
      props.addScore('end');
    }
  }, [matches]);

  // functions
  const checker = async (card) => {
    setWait(true);
    if (card.name === firstCard.name) {
      setTimeout(() => {
        setTimeout(() => {
          card["passed"] = true;
          firstCard["passed"] = true;
          changeCardStatusHandler(card);
          changeCardStatusHandler(firstCard);
          setWait(false);
        }, props.clickDelay * 1500);
        props.addScore();
        setMatches(prevMatch => prevMatch - 1);
        props.playSound(props.sfx.match);
      }, props.clickDelay * 1000);
    } else {
      setTimeout(() => {
        setTimeout(() => {
          changeCardStatusHandler(card);
          changeCardStatusHandler(firstCard);
          setWait(false);
          props.playSound(props.sfx.cardReset);
        }, props.clickDelay * 1000);
        props.playSound(props.sfx.noMatch);
      }, props.clickDelay * 1000);
    }
    
  };

  const changeCardStatusHandler = async (clickedCard) => {
    if (!clickedCard.passed) clickedCard.isFlipped = !clickedCard.isFlipped;
    let index = cardsState.findIndex((card) => card.id === clickedCard.id);
    let newState = [...cardsState];
    newState.splice(index, 1, clickedCard);
    await setCardsState(newState);
  };

  const handleClick = async (e, clickedCard) => {
    if(firstCard?.id == clickedCard.id || clickedCard.passed) return;

    if (wait) {
      return;
    }
    if (!secondClick) {
      await setFirstCard(clickedCard);
      await setSecondClick(true);
      changeCardStatusHandler(clickedCard);
    } else {
      await setSecondClick(false);
      changeCardStatusHandler(clickedCard);
      checker(clickedCard);
      setFirstCard(null);
    }
    props.playSound(props.sfx.cardFlip);
  };

  return (
    <div id="gamePage">
      <section className="memory-game">
        {cardsState?.map((card) => {
          return (
            <Card
              key={card.id}
              card={card}
              onClick={(e) => handleClick(e, card)}
            />
          );
        })}
      </section>
    </div>
  );
}

export default Game;
